// Third-party
import React from 'react';
import { FormattedHTMLMessage as ReactIntlFormattedHTMLMessage } from 'react-intl';

// Utils
import { formatHTMLMessageWithLocale } from './i18n';
import Dictionary from '@/types/dictionary';
import Locale from '@/types/locale';

type Props = React.ComponentProps<typeof ReactIntlFormattedHTMLMessage> & {
  locale?: Locale;
};

const FormattedHTMLMessage = ({ locale, id, values, defaultMessage }: Props) => {
  if (locale) {
    return <span>{formatHTMLMessageWithLocale(id, locale, values as Dictionary<string | number>, defaultMessage)}</span>;
  }

  return <ReactIntlFormattedHTMLMessage id={id} values={values} defaultMessage={defaultMessage} />;
};

export default FormattedHTMLMessage;
